import React from "react";
import {
    Box,
    Typography,
    Divider,
    List,
    ListItem,
    ListItemText,
    Button,
    Grid,
} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";

const LoanDetails = ({ loan, selectedLoan }) => {
    if (!loan) {
        return (
            <Typography color="text.secondary">
                Please select a loan to see details.
            </Typography>
        );
    }

    return (
        <Box sx={{ p: 3, my: 2, borderRadius: 3, bgcolor: "white", boxShadow: 2 }}>
            {/* Loan Title */}
            <Typography variant="h6" fontWeight="bold" gutterBottom>
                {selectedLoan.product_name}
            </Typography>

            {/* Loan Info */}
            <Box sx={{ mb: 2 }}>
                {[
                    { label: "Payment Cycle", value: loan.payment_cycle || "monthly" },
                    { label: "Duration", value: loan.payment_duration || "2 months" },
                    { label: "Start Date", value: loan.payment_start_date || "2025-09-17" },
                    { label: "Actual End Date", value: loan.payment_actual_end_date || "2025-09-24" },
                    {
                        label: "Extension End Date",
                        value: loan.payment_extension_end_date || "2025-11-05",
                    },
                    {
                        label: "Principal Amount",
                        value: `₦${loan.principal_amount?.toLocaleString() || "1,000.00"}`,
                    },
                    {
                        label: "Interest",
                        value: `₦${loan.payment_interest?.toLocaleString() || "100.00"}`,
                    },
                    {
                        label: "Total Payable",
                        value: `₦${loan.total_payable_amount?.toLocaleString() || "1,100.00"}`,
                        bold: true,
                    },
                    {
                        label: "Recurring Payment",
                        value: `₦${loan.recursive_payment_amount?.toLocaleString() || "550.00"}`,
                    },
                ].map((item, idx) => (
                    <Box
                        key={idx}
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            py: 0.6,
                            borderBottom: idx < 8 ? "1px dashed #eee" : "none",
                        }}
                    >
                        <Typography variant="body2" color="text.secondary">
                            {item.label}
                        </Typography>
                        <Typography
                            variant="body2"
                            fontWeight={item.bold ? "bold" : "500"}
                            color={item.bold ? "primary" : "text.primary"}
                        >
                            {item.value}
                        </Typography>
                    </Box>
                ))}
            </Box>

            <Divider sx={{ my: 2 }} />

            {/* Payment Schedule */}
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <EventIcon color="error" sx={{ mr: 1 }} />
                <Typography variant="subtitle1" fontWeight="bold">
                    Payment Schedule
                </Typography>
            </Box>

            <List>
                {(loan.full_payment_schedule || [
                    { id: 1, due: loan.full_payment_schedule, amount: 550, cycle: "weekly" },
                    { id: 2, due: "2025-09-24", amount: 550, cycle: "weekly" },
                ]).map((payment, index) => (
                    <ListItem
                        key={payment.payment_number || index}
                        sx={{
                            px: 0,
                            py: 1,
                            borderBottom: "1px solid #f0f0f0",
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <ListItemText
                            primary={
                                <Typography fontWeight="600">
                                    Payment {index + 1}
                                </Typography>
                            }
                            secondary={`Due: ${payment.payment_due_date} • ${payment.payment_period}`}
                        />
                        <Typography fontWeight="bold" color="primary">
                            ₦{payment.payment_amount?.toLocaleString()}
                        </Typography>
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};

export default LoanDetails;
